<template>
  <div v-if="isLoading" class="text-center my-5">
    <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;">
      <span class="visually-hidden">Chargement...</span>
    </div>
    <p class="mt-2">Chargement des services...</p>
  </div>

  <div v-else class="container-fluid py-4">
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique flex-wrap">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-clipboard2-pulse fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Liste des Services</h2>
      </div>
      <button class="btn btn-primary btn-lg shadow-sm btn-clinique" @click="creation">
        <i class="bi bi-plus-circle me-1"></i>
      </button>
    </div>

    <!-- Filtres -->
    <div class="card p-3 mb-4 shadow-sm rounded card-clinique">
      <div class="row g-3 align-items-end">
        <div class="col-md-3">
          <label class="form-label fw-semibold">Rechercher</label>
          <input
            type="text"
            v-model="searchQuery"
            placeholder="Libellé ou type..."
            class="form-control form-control-clinique"
          >
        </div>

        <div class="col-md-2">
          <label class="form-label fw-semibold">Items / page</label>
          <select v-model="itemsperpage" class="form-select form-select-clinique">
            <option v-for="n in itemsPerPageT" :key="n" :value="n">{{ n }}</option>
          </select>
        </div>

        <div class="col-md-3">
          <label class="form-label fw-semibold">Trier par</label>
          <select v-model="orderBy" class="form-select form-select-clinique">
            <option v-for="(v, k) in orderByTabs" :key="k" :value="v">{{ k }}</option>
          </select>
        </div>

        <div class="col-md-2">
          <label class="form-label fw-semibold">Ordre</label>
          <select v-model="sortOrder" class="form-select form-select-clinique">
            <option v-for="(v, k) in sortOrders" :key="k" :value="v">{{ k }}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Tableau -->
    <div class="card shadow-sm rounded card-clinique">
      <div class="table-responsive">
        <table class="table align-middle text-center mb-0 table-hover modern-table-clinique">
          <thead>
            <tr>
              <th>#</th>
              <th>Service</th>
              <th>Type</th>
              <th>Code</th>
              <th>Prix (FCFA)</th>
              <th>Statut</th>
              <th>Créé le</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(service, index) in filteredServices" :key="service.id">
              <td>{{ index + 1 + (currentPage - 1) * itemsperpage }}</td>
              <td>{{ service.nom }}</td>
              <td>{{ service.type?.nom || '-' }}</td>
              <td>{{ service.code || '-' }}</td>
              <td class="fw-semibold">{{ formatPrice(service.prix) }}</td>
              <td>
                <span :class="['badge', service.isEnabled ? 'bg-success' : 'bg-danger']">
                  {{ service.isEnabled ? 'Activé' : 'Désactivé' }}
                </span>
              </td>
              <td>{{ formatDate(service.createdAt) }}</td>
              <td>
                <div class="dropdown">
                  <button class="btn btn-sm btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown">
                    Actions
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item" @click="modifier(service.id)">Modifier</a>
                    </li>
                    <li>
                      <a class="dropdown-item text-danger" @click="supprimer(service.id)">Supprimer</a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>

            <tr v-if="services.length === 0">
              <td colspan="7" class="text-center py-3">Aucune donnée disponible</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="d-flex justify-content-end p-3">
        <ul class="pagination pagination-modern mb-0">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="changePage(currentPage - 1)">Précédent</button>
          </li>

          <li
            v-for="page in totalPages"
            :key="page"
            class="page-item"
            :class="{ active: page === currentPage }"
          >
            <button class="page-link" @click="changePage(page)">{{ page }}</button>
          </li>

          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="changePage(currentPage + 1)">Suivant</button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  name: 'ListeService',
  data() {
    return {
      isLoading: true,
      services: [],
      searchQuery: '',
      itemsperpage: 50,
      currentPage: 1,
      totalItems: 0,
      orderBy: 'ser.nom',
      sortOrder: 'asc',
      itemsPerPageT: [50, 100,150, 200],
      orderByTabs: {
        Service: 'ser.nom',
        Prix: 'ser.prix',
        Type: 'ts.libelle'
      },
      sortOrders: {
        Croissant: 'asc',
        Décroissant: 'desc'
      },
      isFirstLoad: true
    };
  },
  computed: {
    filteredServices() {
      if (!this.searchQuery) return this.services;
      return this.services.filter(s =>
        s.nom.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        s.type?.nom.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
    totalPages() {
      return Math.ceil(this.totalItems / this.itemsperpage);
    }
  },
  methods: {
    creation() {
      this.$router.push({ name: 'create_service' });
    },
    async getServices() {
      if (this.isFirstLoad) {
        this.isLoading = true;
        this.isFirstLoad = false;
      }
      try {
        const res = await api.getItems('services', {
          page: this.currentPage,
          itemsperpage: this.itemsperpage,
          orderBy: this.orderBy,
          sortOrder: this.sortOrder,
          search: this.searchQuery
        });
        const { data, meta } = res.data;
        this.services = data;
        this.totalItems = meta?.total_records || data.length;
      } catch (e) {
        console.error('Erreur chargement services', e);
      } finally {
        this.isLoading = false;
      }
    },
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
        this.getServices();
      }
    },
    modifier(id) {
      this.$router.push({ name: 'edit_service', params: { id } });
    },
    async supprimer(id) {
      if (!confirm('Voulez-vous supprimer ce service ?')) return;
      try {
        this.isLoading = true;
        await api.deleteItem('services', id);
        this.getServices();
      } catch (e) {
        alert('Erreur lors de la suppression');
      } finally {
        this.isLoading = false;
      }
    },
    formatDate(date) {
      if (!date) return '-';
      return new Date(date).toLocaleDateString('fr-FR');
    },
    formatPrice(val) {
      return new Intl.NumberFormat('fr-FR').format(val);
    }
  },
  watch: {
    searchQuery() { this.currentPage = 1; this.getServices(); },
    itemsperpage() { this.currentPage = 1; this.getServices(); },
    orderBy() { this.getServices(); },
    sortOrder() { this.getServices(); }
  },
  created() {
    this.getServices();
  }
};
</script>

<style scoped>
.header-clinique {
  padding: 15px 20px;
  background-color: #e9f5ff;
  border-radius: 12px;
  margin-bottom: 20px;
}
.card-clinique {
  background: #f8fafd;
  border-radius: 12px;
  border: none;
}
.form-control-clinique,
.form-select-clinique {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
}
.modern-table-clinique thead {
  background: linear-gradient(90deg, #8fd3f4, #0d6efd);
  color: #fff;
}
.badge {
  border-radius: 12px;
}
.pagination-modern .page-link {
  border-radius: 50%;
}
</style>
